import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { microTask as s } from './micro-task.js';
function m() {
  var n = [],
    i = [],
    r = {
      enqueue: function enqueue(e) {
        i.push(e);
      },
      addEventListener: function addEventListener(e, t, a, o) {
        return e.addEventListener(t, a, o), r.add(function () {
          return e.removeEventListener(t, a, o);
        });
      },
      requestAnimationFrame: function (_requestAnimationFrame) {
        function requestAnimationFrame() {
          return _requestAnimationFrame.apply(this, arguments);
        }
        requestAnimationFrame.toString = function () {
          return _requestAnimationFrame.toString();
        };
        return requestAnimationFrame;
      }(function () {
        var t = requestAnimationFrame.apply(void 0, arguments);
        return r.add(function () {
          return cancelAnimationFrame(t);
        });
      }),
      nextFrame: function nextFrame() {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }
        return r.requestAnimationFrame(function () {
          return r.requestAnimationFrame.apply(r, e);
        });
      },
      setTimeout: function (_setTimeout) {
        function setTimeout() {
          return _setTimeout.apply(this, arguments);
        }
        setTimeout.toString = function () {
          return _setTimeout.toString();
        };
        return setTimeout;
      }(function () {
        var t = setTimeout.apply(void 0, arguments);
        return r.add(function () {
          return clearTimeout(t);
        });
      }),
      microTask: function microTask() {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }
        var t = {
          current: !0
        };
        return s(function () {
          t.current && e[0]();
        }), r.add(function () {
          t.current = !1;
        });
      },
      add: function add(e) {
        return n.push(e), function () {
          var t = n.indexOf(e);
          if (t >= 0) {
            var _n$splice = n.splice(t, 1),
              _n$splice2 = _slicedToArray(_n$splice, 1),
              a = _n$splice2[0];
            a();
          }
        };
      },
      dispose: function dispose() {
        var _iterator = _createForOfIteratorHelper(n.splice(0)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var e = _step.value;
            e();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      },
      workQueue: function workQueue() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _iterator2, _step2, e;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _iterator2 = _createForOfIteratorHelper(i.splice(0));
                _context.prev = 1;
                _iterator2.s();
              case 3:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 9;
                  break;
                }
                e = _step2.value;
                _context.next = 7;
                return e();
              case 7:
                _context.next = 3;
                break;
              case 9:
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                _iterator2.e(_context.t0);
              case 14:
                _context.prev = 14;
                _iterator2.f();
                return _context.finish(14);
              case 17:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[1, 11, 14, 17]]);
        }))();
      }
    };
  return r;
}
export { m as disposables };